import getBookPropertiesFromBackendData from '../getBookPropertiesFromBackendData';
import getBookPropertiesFromLocalSettings from '../getBookPropertiesFromLocalSettings';

/**
 * @method getMostRecentBook
 * @param {Object} epubLocationHistoryData - payload of location history data from the backend
 * @returns {Number} a Book primary key
 */
const getMostRecentBookPk = (epubLocationHistoryData) => {
  const bookPropertiesFromLocalSettings = getBookPropertiesFromLocalSettings();
  const bookPropertiesFromBackendData = getBookPropertiesFromBackendData(
    epubLocationHistoryData,
  );

  if (bookPropertiesFromBackendData && bookPropertiesFromLocalSettings) {
    // If both sources have data, return the book pk with the most recent timestamp
    return bookPropertiesFromBackendData.timestamp >=
      bookPropertiesFromLocalSettings.timestamp
      ? bookPropertiesFromBackendData.pk
      : bookPropertiesFromLocalSettings.pk;
  }

  // Otherwise return whatever is available.
  return (
    bookPropertiesFromBackendData?.pk ??
    bookPropertiesFromLocalSettings?.pk ??
    null
  );
};

export default getMostRecentBookPk;
